import React from 'react';
import { PropTypes } from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const FormTypeCellRenderer = ({
  data: form
}) => <div>{ (form && form.formTypeDescription && `${ form.formTypeDescription }${ form.isOnlineForm ? ' (Online)' : '' }`) || 'N/A' }</div>;

FormTypeCellRenderer.propTypes = {
  data: PropTypes.shape(),
  context: PropTypes.shape({})
};

FormTypeCellRenderer.defaultProps = {
  context: {},
  data: {}
};
